module.exports = __webpack_public_path__ + "media/images/appIcon-9d90bd9c69cfe739cb16faf6a4edcf93.png";